import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_route/_internal/searches/')({
  beforeLoad: () => {
    const defaultSearch: {
      order: 'asc' | 'desc';
      sort: 'created';
      status: Array<'active'>;
    } = {
      order: 'desc',
      sort: 'created',
      status: ['active'],
    };

    throw redirect({
      replace: true,
      search: () => defaultSearch,
      to: '/pipelines',
    });
  },
});
